import React, { useEffect } from 'react';

import logo from '~/assets/logo-white.png';

import { Container, Body } from './styles';

export default function Exit() {
    useEffect(() => {
        window.close();
    }, []);

    return (
        <Container>
            <Body>
                <img src={logo} alt="Pluginbot Logo" title="Pluginbot Logo" />
            </Body>
        </Container>
    );
}
